import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 審閱契約1 PostBack
 */
const RiskWarningContractPostBack = [
    'POST',
    RouteUrlList.API_RiskWarningContractPostBack.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: ''
    }
];
export default RiskWarningContractPostBack;
